"use client";

import { useEffect } from "react";

const DOCUMENT_READY_STATE_COMPLETE = "complete";
const WINDOW_LOAD_EVENT = "load";
const GALLERY_CHUNK_PRELOAD_DELAY_MS = 1_500;

function preloadGalleryChunk(): void {
  // The gallery the "All teams" intent opens…
  void import("@/components/ui/Cnetflixgallery").catch(() => undefined);
  // …and the chunk its team clicks (and the landing's own details intents)
  // resolve to — the standalone team overlay still lives with the old deck.
  void import("@/components/ui/Cteamsgallery").catch(() => undefined);
}

export function useGalleryChunkPreload(): void {
  useEffect(() => {
    let cancelScheduledPreload: VoidFunction | undefined;

    const scheduleGalleryChunkPreload = (): void => {
      if (typeof window.requestIdleCallback === "function") {
        let idleCallbackId: number | undefined;
        const timeoutId = window.setTimeout(() => {
          idleCallbackId = window.requestIdleCallback(preloadGalleryChunk);
        }, GALLERY_CHUNK_PRELOAD_DELAY_MS);
        cancelScheduledPreload = () => {
          window.clearTimeout(timeoutId);
          if (idleCallbackId !== undefined) {
            window.cancelIdleCallback(idleCallbackId);
          }
        };
        return;
      }

      const timeoutId = window.setTimeout(
        preloadGalleryChunk,
        GALLERY_CHUNK_PRELOAD_DELAY_MS,
      );
      cancelScheduledPreload = () => {
        window.clearTimeout(timeoutId);
      };
    };

    if (document.readyState === DOCUMENT_READY_STATE_COMPLETE) {
      scheduleGalleryChunkPreload();
    } else {
      window.addEventListener(WINDOW_LOAD_EVENT, scheduleGalleryChunkPreload, {
        once: true,
      });
    }

    return () => {
      window.removeEventListener(WINDOW_LOAD_EVENT, scheduleGalleryChunkPreload);
      cancelScheduledPreload?.();
    };
  }, []);
}
